<template lang="pug">
  main
    NavBarAccesos
    Loader(v-show="isLoading")
    ModalDelete(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:eliminar="cancelarEntrada")
    ModalInfo(v-show="modalStatus2" :title="titleModal2" :content="contentModal2" @padre:close="cerrarModal")
    section.section(v-show="!isLoading")
      .container
        h3.title.is-3 Lista de Verificación para Carga de Gas LP de Autotanques
          | &nbsp
          a.button.is-dark.is-rounded.is-medium(@click="regresar_AddPGS")
            i.fas.fa-times
        .columns
          .column.is-half
            .card
              header.card-header
                p.card-header-title Id Veridicación: {{ verificacion.id }}
              .card-content
                .content
                  p 📅 Fecha Recepción: {{ verificacion.fechaRecepcion }}
                  p 🚚 Operador: {{ verificacion.nombreOperador }}
                  p 👷 Verificador: {{ verificacion.nombreVerificador }}
          .column.is-half
            .card
              header.card-header
                p.card-header-title Autotanques Recibidos
              .card-content
                .content
                  .pgsVerif(v-for="(tanque, index) in autotanques" :key="tanque.id")
                    span.button.btn-autotanque(
                      @click="selectTanque(tanque, index)",
                      :class="{'is-danger': tanque.emplazado, 'is-ligth': !tanque.emplazado}",
                      :disabled="tanque.verificado"
                    ) {{ tanque.pg }}
                    span.tag.is-black.tag-vefiricado(v-show="tanque.verificado") Ya ha sido Verificado
        .columns(v-show="isOneSelect")
          .column.is-full
            Puntos(v-show="!verificadosCompletos" @pgVerificado="finishVerificado")
        .columns
          .column.is-full
            button.button.is-primary.is-large.is-fullwidth(@click="salirPuntos" v-show="verificadosCompletos") Continuar
        .columns.column-blanco
</template> 

<script>
import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'
import Puntos from '@/components/sca_Componentes/acceso/Puntos.vue'
import NavBarAccesos from '@/components/sca_Componentes/acceso/layout/NavBarAccesos.vue'
import Loader from '@/components/sca_Componentes/acceso/shared/Loader.vue'
import ModalDelete from '@/components/sca_Componentes/acceso/shared/ModalDelete.vue'
import ModalInfo from '@/components/sca_Componentes/acceso/shared/ModalInfo.vue'
import { mapState } from 'vuex'

export default {
  name: 'ListaVerificacion',
  components: { Puntos, Loader, NavBarAccesos, ModalDelete, ModalInfo },
  data () {
    return {
      verificacion: {},
      isLoading: true,
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      modalStatus2: false,
      contentModal2: '',
      titleModal2: '',
      isOneSelect: false
    }
  },
  methods: {
    obtenerDataVerif () {
      const id = this.$route.params.id
      console.log(id)
      autotanquesServicesIRGE.getVerificacion(id)
        .then(res => {
          console.log(res)
          this.verificacion = res[0]
          this.$store.commit('verificacionActual', this.verificacion)
          this.isLoading = false
        })
    },
    obtenerClases (tanque) {
      this.autotanquesEmplazados.forEach(element => {
        let clase = ''
        if (element.id === tanque.id) {
          clase = 'is-danger'
        } else {
          clase = 'is-info'
        }
        console.log(clase)
        return clase
      })
    },
    selectTanque (tanque, index) {
      this.unselectBtns()
      this.$store.commit('tanqueActual', tanque)
      let btnsPgs = Array.from(document.querySelectorAll('.btn-autotanque'))
      console.log(btnsPgs)
      btnsPgs[index].classList.add('is-dark')
      this.isOneSelect = true
    },
    salirPuntos () {
      this.$router.push('/IRGE/Accesos_IRGE/Emplazados')
    },
    unselectBtns () {
      let btns = Array.from(document.querySelectorAll('.btn-autotanque'))
      btns.forEach(element => {
        element.classList.remove('is-dark')
      })
    },
    regresar_AddPGS () {
      // this.$store.commit('resetTanques')
      this.$router.push('/IRGE/Accesos_IRGE/Agregar')
    },
    mostrarModalDelete () {
      this.titleModal = `Eliminar Verificación.`
      this.contentModal = `🚫 ¿Desea Eliminar la verificación Actual?`
      this.modalStatus = true
    },
    cancelarEntrada (result) {
      if (result === 'delete') {
        this.isLoading = true
        this.modalStatus = false
        autotanquesServicesIRGE.deleteRecepcion(this.verificacion.id)
          .then(data => {
            console.log(data)
            if (data.success) {
              autotanquesServicesIRGE.deletePg_Recepcion(this.verificacion.id)
                .then(res => {
                  if (res.success) {
                    this.isLoading = false
                    this.titleModal2 = 'Recepción Eliminada'
                    this.contentModal2 = `La Recepción se ha Eliminado con Éxito.`
                    this.modalStatus2 = true
                    this.cerrarModal()
                  } else {
                    this.isLoading = false
                    this.titleModal2 = 'Error al eliminar los PG'
                    this.contentModal2 = res.respuesta
                    this.modalStatus2 = true
                  }
                })
            }
          })
      } else {
        this.modalStatus2 = false
      }
    },
    cerrarModal () {
      this.modalStatus2 = false
      this.$store.commit('resetTanques')
      setTimeout(() => {
        this.$router.push('/IRGE/Accesos_IRGE/Agregar')
      }, 1000)
    },
    finishVerificado (verif) {
      console.log(verif)
      this.isOneSelect = false
    }
  },
  created () {
    this.obtenerDataVerif()
  },
  computed: {
    ...mapState(['tanqueActualSel', 'autotanques', 'verificadosCompletos'])
  }
}
</script>

<style lang="css" scoped >
  .column-blanco {
    padding-bottom: 100px;
  }
  .pgsVerif {
    margin-bottom: 20px;
  }
  .tag-vefiricado {
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/ListaVerificacion.vue